<template>
  <div class="default-layout">
    <div
      id="viewport"
      class="w-100 relative"
    >
      <product-list />
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import ProductList from './ProductList.vue';

export default {
    components: {
        ProductList
    },
    mounted () {
         this.getProductsToCardCode();
    },
    methods: {
        ...mapActions('products', ['getProductsToCardCode']),
    },
}
</script>
